export const TileWidgetSlot: Object<string, string> = {
	BEFORE_TILE_LIST: 'beforeTileList',
	AFTER_TILE_LIST: 'afterTileList',
	BEFORE_DROP_AREA: 'beforeDropArea',
	AFTER_DROP_AREA: 'afterDropArea',
	ITEM_EXTRA_ACTION: 'Item:extraAction',
};